import React, { Component } from "react";
import "./SupportIssueInfo.css";

const TicketStatus = ({ ticket }) => {
  return (
    <div className="info-container status">
      <h3>Ticket Status</h3>
      <div
        className={ticket.status === "solved" || ticket.status === "closed" ? "resolved" : "open"}
      >
        <div>
          <h4>{ticket.status === "solved" || ticket.status === "closed" ? "Resolved" : "Open"}</h4>
        </div>
        <div className="status-icon-container">
          <span
            className={
              "status-icon fa " +
              (ticket.status === "solved" || ticket.status === "closed"
                ? "fa-check-circle"
                : "fa-ellipsis-h")
            }
          />
        </div>
      </div>
    </div>
  );
};

const EmailRecipients = ({ emailCCs, requester }) => {
  let emailRecipients = emailCCs;
  if (!emailRecipients.includes(requester)) {
    emailRecipients.push(requester);
  }
  let commentNodes = emailRecipients.map(emailAddress => {
    return (
      <div>
        <span>{emailAddress}</span>
        <br />
      </div>
    );
  });
  return (
    <div className="info-container recipients">
      <h3>Included in Conversation</h3>
      <div className="emailRecipientList">{commentNodes}</div>
    </div>
  );
};

class SupportIssueInfo extends Component {
  render() {
    return (
      <div className="support-issue-info">
        <div className="ticket-address">
          <h3>Address</h3>
          <span>{this.props.ticket.address}</span>
        </div>
        <div className="ticket-last-updated">
          <h3>Last Updated</h3>
          <span>{this.props.ticket.updatedAtFormatted}</span>
        </div>
        <div className="ticket-email-ccs">
          <EmailRecipients
            emailCCs={this.props.ticket.emailCc}
            requester={this.props.ticket.requester}
          />
        </div>
        <div className="ticket-status">
          <TicketStatus ticket={this.props.ticket} />
        </div>
      </div>
    );
  }
}

export default SupportIssueInfo;
